import { Grid, Box, Typography } from '@mui/material'
import React from 'react'
import Emoticons from '../components/Emoticons';
import api from '../api/axios';
import ReactionBarChart from '../components/ReactionBarChart';
import ProjectMeterageChart from '../components/ProjectMeterage';
import CumulativeMeterageChart from "../components/CumulativeMeterageChart";
import RigDonutChart from "../components/RigDonutChart";
import RigCompletedBoreholesChart from "../components/RigCompletedBoreholesChart";
import RigStatusWidget from '../components/RigStatusWidget';

function Dashboard() {
  const [refreshKey, setRefreshKey] = React.useState(0);
  const handleEmoticonClick = async (label) => {
    try {
      const response = await api.post('/dashboard/save_reaction', { reaction: label });
      setRefreshKey(prev => prev + 1);
    } catch (error) {
      console.error('Error saving reaction:', error);
    }
  };

  return (
    <>
    <Typography variant="h5" fontWeight={600} m={2} p={2}>
      How are you feeling today?
    </Typography>
      <Grid container spacing={2} mt={2}>
        <Grid item size={{ xs: 4, sm: 4, md: 4, lg: 4, xl: 4 }} p={4} sx={{ borderRight: "1px solid rgba(255,255,255,0.12)" }}>
          <Grid container spacing={2} justifyContent="center">
            <Grid item size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }} textAlign="center">
              <Emoticons symbol="🥳" label="Party" onClick={() => handleEmoticonClick("party")} />
                </Grid>
            <Grid item size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }} textAlign="center">
              <Emoticons symbol="😃" label="Happy" onClick={() => handleEmoticonClick("happy")} />
                </Grid>
            <Grid item size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }} textAlign="center">
              <Emoticons symbol="🤔" label="Thinking" onClick={() => handleEmoticonClick("thinking")} />
                </Grid>
            <Grid item size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }} textAlign="center">
              <Emoticons symbol="😴" label="Sleepy" onClick={() => handleEmoticonClick("sleepy")} />
                </Grid>
            <Grid item size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }} textAlign="center">
              <Emoticons symbol="😫" label="Tired" onClick={() => handleEmoticonClick("tired")} />
                </Grid>
            <Grid item size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }} textAlign="center">
              <Emoticons symbol="🤬" label="Angry" onClick={() => handleEmoticonClick("angry")} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item size={{ xs: 8, sm: 8, md: 8, lg: 8, xl: 8 }}>
          <ReactionBarChart refreshKey={refreshKey} />
        </Grid>
      </Grid>

      {/* ================= Project Meterage ================= */}

    <Box mt={4}>
      <ProjectMeterageChart />
    </Box>

    <Box mt={4}>
      <CumulativeMeterageChart />
    </Box>

    {/* ================= Rig Status ================= */}
    <RigStatusWidget />

    <Grid container spacing={2} sx={{ mt: 1 }}>
    <Grid size={{ xs: 12, md: 6 }}>
      <RigDonutChart />
    </Grid>

    <Grid size={{ xs: 12, md: 6 }}>
      <RigCompletedBoreholesChart />
    </Grid>
  </Grid>
    </>
  )}

export default Dashboard
